import React, { useState } from "react";
import Modal from 'react-modal';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

import Menu from './Menu';

import './ProjetTest.css';

const DynamismeBonnevoie = () =>{
    
     const [video100, setVideo100] = useState(false);
     const [video110, setVideo110] = useState(false);
     const [video120, setVideo120] = useState(false);
     const [video130, setVideo130] = useState(false);
     const [video200, setVideo200] = useState(false);
     const [video210, setVideo210] = useState(false);
     const [video220, setVideo220] = useState(false);
     const [video700, setVideo700] = useState(false);
     const [video710, setVideo710] = useState(false);
     const [video800, setVideo800] = useState(false);
 

    
     const handleVideo100 = () =>{
         setVideo100(true);
 
     }
     const handleVideo110 = () =>{
         setVideo110(true);
 
     }
     const handleVideo120 = () =>{
         setVideo120(true);
 
     }
     const handleVideo130 = () =>{
         setVideo130(true);
 
     }
     const handleVideo200 = () =>{
         setVideo200(true);
 
     }
     const handleVideo210 = () =>{
         setVideo210(true);
 
     }
     const handleVideo220 = () =>{
         setVideo220(true);
 
     }
     const handleVideo700 = () =>{
         setVideo700(true);
 
     }
     const handleVideo710 = () =>{
         setVideo710(true);
 
     }
     const handleVideo800 = () =>{
         setVideo800(true);
 
     }
     const handleClose = () =>{
         setVideo100(false);
         setVideo110(false);
         setVideo120(false);
         setVideo130(false);
         setVideo200(false);
         setVideo210(false);
         setVideo220(false);
         setVideo700(false);
         setVideo710(false);
         setVideo800(false);
     
     }
 

    return(
        <>
        <Menu></Menu>
<div className="envelope-projeto">
    
    
   
        <div className="banner-projeto">
            <div className="poster_onglet">
              
                </div>
                <div className="poster_onglet_700">
              
              </div>
        </div>
        
        <div className="grid-container-projeto container-projet">

            <div className="grid-item-projeto grid-video" id="grid1-projeto">
                        <div className="image-container-carte">
                            <img src="./images/Projet/01 Les dynamiques 07.59.00.png" alt="Vivre ensemble dans le quartier de Bonnevoie" onClick={handleVideo100}></img>
                     </div>
                      
                        <div className="container-projeto-button">
                        <p className="text-video">Vivre ensemble dans le quartier de Bonnevoie (DE)</p>
            
                            <button className="projeto-button" onClick={handleVideo100}> 
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video100}
                            onRequestClose = {()=> setVideo100(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Vivre ensemble dans le quartier de Bonnevoie (DE)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/EQujWXDNxpE?si=EyTTo2LEuo4wJbVV" 
                             allowFullScreen></iframe>                   </div>
            
                        </Modal>
                    </div>    
            
            
                    <div className="grid-item-projeto grid-video" id="grid2-projeto">
                        <div className="image-container-carte" onClick={handleVideo110}>
                            <img src="./images/Projet/02 Les dynamiques 08.00.07.png" alt="En bonne entente associative à Bonnevoie"></img>
           
            
                        </div>
                      
                         
                        <div className="container-projeto-button">
                        <p className="text-video">En bonne entente associative à Bonnevoie (DE)</p>
            
                            <button className="projeto-button" onClick={handleVideo110}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video110}
                            onRequestClose = {()=> setVideo110(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>En bonne entente associative à Bonnevoie (DE)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/gsfTWoAbGgE?si=RaVmMuB_-xHLylNb" 
                             allowFullScreen></iframe>            
                            
                            </div>
                           
                        </Modal>
                      
            
                    </div>
                    <div className="grid-item-projeto grid-video" id="grid3-projeto">
                        <div className="image-container-carte" onClick={handleVideo120}>
                        <img src="./images/Projet/03 Les dynamiques 08.02.48.png" alt="Vivre ensemble et interagir ensemble"></img>
            
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                        </div>
                     
                           
                        <div className="container-projeto-button"onClick={handleVideo120}>
                        <p className="text-video">Vivre ensemble et interagir ensemble (DE)
                        </p>
                            <button className="projeto-button" onClick={handleVideo120}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video120}
                            onRequestClose = {()=> setVideo120(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Vivre ensemble et interagir ensemble (DE)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/9BN2XFXjOMA?si=qc3ikdXWWD_6U0np" 
                            allowFullScreen></iframe>                
                            </div>
                           
                        </Modal>
            
                    </div>
                    <div className="grid-item-projeto grid-video" id="grid4-projeto">
                        <div className="image-container-carte"onClick={handleVideo130}>
                            <img src="./images/Projet/04 Les dynamiques 08.04.25.png" alt="Bonnevoie à l’image des autres quartiers"></img>
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/hTbYa9SJHAE?si=hYEb--Ts-D6LdyYb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                        </div>
                    
                        <div className="container-projeto-button">
                        <p className="text-video">Bonnevoie à l’image des autres quartiers (DE)
                        </p>
                            <button className="projeto-button" onClick={handleVideo130}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video130}
                            onRequestClose = {()=> setVideo130(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Bonnevoie à l’image des autres quartiers (DE)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/anDrX5n9FaA?si=w2CxzbZjmv8fsd2I"
                             allowFullScreen></iframe>             
                            </div>
                           
                        </Modal>
            
                    </div>
                    <div className="grid-item-projeto grid-video" id="grid5-projeto">
                        <div className="image-container-carte" onClick={handleVideo200}>
                            <img src="./images/Projet/05 Les dynamiques 08.08.48.png" alt="Se sentir chez soi dans son quartier"></img>
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/HLZRqDpd2m4?si=8Ln9FTBoQ3SJVLWu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                        </div>
                    
                        <div className="container-projeto-button">
                        <p className="text-video">Se sentir chez soi dans son quartier (PT)
                        </p>
                            <button className="projeto-button" onClick={handleVideo200}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video200}
                            onRequestClose = {()=> setVideo200(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Se sentir chez soi dans son quartier (PT)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/P9Y872Q_-ys?si=QA4tKCdFnFqkbG-m" 
                             allowFullScreen></iframe>
                            </div>
                           
                        </Modal>
            
                    </div>  
                    <div className="grid-item-projeto grid-video" id="grid6-projeto">
                    <div className="image-container-carte" onClick={handleVideo210}>
                    <img src="./images/Projet/06 Les dynamiques 08.09.24.png" alt="Être en contact les uns les autres"></img>
            
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                        </div>
                    
                        <div className="container-projeto-button">
                        <p className="text-video" >Être en contact les uns les autres (EN)
                        </p>
                            <button className="projeto-button" onClick={handleVideo210}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video210}
                            onRequestClose = {()=> setVideo210(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Être en contact les uns les autres (EN)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/fGRR9OHwWu8?si=zfa19NsLccUG7DQq" 
                            allowFullScreen></iframe>
                            </div>
                           
                        </Modal>
            
                    </div>  
                    <div className="grid-item-projeto grid-video" id="grid7-projeto">
                    <div className="image-container-carte" onClick={handleVideo220}>
                    <img src="./images/Projet/07 Les dynamiques 08.12.29.png" alt="Bonnevoie, un quartier dynamique"></img>
            
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                        </div>
                   
            
                        <div className="container-projeto-button">
                        <p className="text-video" >Bonnevoie, un quartier dynamique (EN)
                        </p>
                            <button className="projeto-button" onClick={handleVideo220}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video220}
                            onRequestClose = {()=> setVideo220(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Bonnevoie, un quartier dynamique (EN)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/AwJQXVlwZX8?si=jGjKbZKiNhZv5vk-"
                             allowFullScreen></iframe>
                            </div>
                           
                        </Modal>
            
            
                    </div>  
                    <div className="grid-item-projeto grid-video" id="grid8-projeto">
                    <div className="image-container-carte" onClick={handleVideo700}>
                        <img src="./images/Projet/08 Les dynamiques 08.14.04.png" alt="Aller au Tennis club de Bonnevoie, le samedi matin"></img>
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                    
                        </div>
            
            
                        <div className="container-projeto-button">
                        <p className="text-video">Aller au Tennis club de Bonnevoie, le samedi matin (EN)
                        </p>
                            <button className="projeto-button" onClick={handleVideo700}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video700}
                            onRequestClose = {()=> setVideo700(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Aller au Tennis club de Bonnevoie, le samedi matin (EN)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/N2mKJrBJXzg?si=Hx172GgrcAzyC-z3"
                             allowFullScreen></iframe>
                                            </div>
                           
                        </Modal>
            
            
                    </div>     
                    <div className="grid-item-projeto grid-video" id="grid9-projeto">
                    <div className="image-container-carte" onClick={handleVideo710}>
                    <img src="./images/Projet/09 Les dynamiques 08.16.03.png" alt="Le parc Kaltreis à Bonnevoie"></img>
            
            {/*             <iframe width="100%" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=2zCUP7Z9e-ySE4I_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
             */}
                        </div>
                     
            
                        <div className="container-projeto-button">
                        <p className="text-video">Le parc Kaltreis à Bonnevoie (FR)
                        </p>
                            <button className="projeto-button" onClick={handleVideo710}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video710}
                            onRequestClose = {()=> setVideo710(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"><h2>Le park Kaltreis à Bonnevoie (FR)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/Gy3hzMggs-E?si=fHxam7pNn04UR1_v" 
                            allowFullScreen></iframe>                                </div>
                           
                        </Modal>
            
            
                    </div>   
                    <div className="grid-item-projeto grid-video" id="grid10-projeto">
                    <div className="image-container-carte"  onClick={handleVideo800}>
                        <img src="./images/Projet/10 Les dynamiques 08.19.16.png" alt="Rejoignez-nous"></img>
            
                        </div>
                 
            
                        <div className="container-projeto-button">
                        <p className="text-video"> Rejoignez-nous (FR)
                        </p>
                            <button className="projeto-button" onClick={handleVideo800}>  
                            </button>
            
                        </div>
                        <Modal 
                            className="modal-content-video" 
                            isOpen={video800}
                            onRequestClose = {()=> setVideo800(false)}
                            overlayClassName="modal-overlay"
                            ariaHideApp={false}
                            
                        >
                            <div className='close-modal-home'>
                                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                            </div>
                            <div className="title-video"> <h2> Rejoignez-nous (FR)</h2></div>
                                                
                            <div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/cXeOmF-Ll5U?si=dG3I2JP20mLZWFxf" 
                            allowFullScreen></iframe>          
                            </div>
                           
                        </Modal>
            
                    </div>  
                          
</div>  
</div>

        </>
    );
}

export default DynamismeBonnevoie;